import { Link } from "react-router-dom";

export function Logo({ className = "", onClick, height = "h-8" }) {
  return (
    <Link to="/" onClick={onClick} className={`flex items-center ${className}`} data-testid="logo" aria-label="FlowCore home">
      <img
        src="/flowcore-lockup-dark.png"
        alt="FlowCore"
        className={`${height} w-auto select-none`}
        draggable="false"
      />
    </Link>
  );
}
